module.exports = __webpack_public_path__ + "img/googlemybusiness-instruction-3.0a4530cb.png";